import {Link, useParams, useNavigate} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as Tooltip1, Legend, LineChart, Line } from 'recharts';

//import { , XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
//import { DotItemDotProps } from 'recharts/types/util/types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';

import './css/analytics.css';

class PortalServiceAnalytics extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			
			view: {
				charts: '',
				page: '',
			},
			
			platforms: {
				followers: [],
				platforms: []
			},

			djs: [],
			djsChart: [
				{bar: 'viewers', enabled: true, fill: "#6A5ACD"},
				{bar: 'hours', enabled: true, fill: "#A8CAE6"},
				{bar: 'performances', enabled: true, fill: "#E3B321"},
				{bar: 'followers', enabled: true, fill: "#86AE11"},
				{bar: 'messages', enabled: false, fill: "#ED8D51"},
				{bar: 'twitch_bits', enabled: true, fill: "#219696"},
				{bar: 'twitch_subscribe', enabled: true, fill: "#C95050"},
				{bar: 'twitch_trains', enabled: true, fill: "#8F548F"}
			],

			start: Math.floor(Date.now()/1000),
			end: Math.floor(Date.now()/1000)
		};
    this.getAnalytics = this.getAnalytics.bind(this);
		this.setView = this.setView.bind(this);
		this.sortDjs = this.sortDjs.bind(this);
		//this.length = this.length.bind(this);
  };

  async componentDidMount() {
		

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		EventEmitter.emit('/client', y);

		this.getAnalytics();
	}

	componentWillUnmount() {
    
	}

	async getAnalytics() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/analytics`, params);
		consoleLog(x.data);
		setTitle('Analytics', x.data.servicename);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				//this.setState({});
				setTitle('Analytics', x.data.servicename);
			}
      x.data.djs.sort((a, b) => a.viewers < b.viewers);
			for( let i in x.data.platforms.platforms ) {
				for( let j in x.data.platforms.platforms[i] ) {
					//console.log(x.data.platforms.platforms[i][j]);
					x.data.platforms.platforms[i][j].date = moment(x.data.platforms.platforms[i][j].ctime*1000).format('DD-MMM');
				}
			}
				
			this.setState({
				service,
				djs: x.data.djs,
				platforms: x.data.platforms,
				view: {charts: 'platforms', page: x.data.platforms.platforms.length-1},
				start: x.data.platforms.start,
				end: x.data.platforms.end
			});
		}
	}


	setView(charts, page = null, enabled = null) {
		let djs = this.state.djs;
		let djsChart = this.state.djsChart;

		if( charts === 'platforms' ) {
			if( page === null ) page = this.state.platforms.platforms.length-1;
		} else {

		}


		this.setState({view: {charts, page}, djs, djsChart});
	}


	sortDjs(bar, enabled = null) {
		
		let djs = this.state.djs;
		let djsChart = this.state.djsChart;
		if( enabled === null ) {
			//console.log(djsChart);

			let element = djsChart.find(elem=>elem.bar===bar);
			element.enabled = true;
			let index = djsChart.findIndex(elem=>elem.bar===bar);
			//console.log(element, index);
	    djsChart.splice(index, 1);
    	djsChart.splice(0, 0, element);
			djs = djs.toSorted((a, b) => b[bar] - a[bar]);

		} else {

			let element = djsChart.find(elem=>elem.bar===bar);
			element.enabled = enabled;

		}

		//console.log(djs, djsChart);
		this.setState({djs, djsChart});
	}

	render() {
    const user = this.context;

		const followers = this.state.platforms.followers.map((e, i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="me-2">
									<div className="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div className="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" className="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots tx-14"></i></a>
									<ul className="dropdown-menu">
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item">Something Else Here</a></li>
									</ul>
									<div className="mg-b-6">
										<p className="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div className="flex-between">
										{/*<h3 className="tx-20 mb-0 font-weight-normal">{e.followers} here</h3>*/}

										<p class="text-lg fw-semibold mb-1">{e.followers}
											{e.month &&
												<OverlayTrigger
													placement="top"
													delay={{ show: 250, hide: 400 }}
													overlay={<Tooltip id="button-tooltip">
														{e.month[1]>0?'Gained':'Lost'} {Math.abs(e.month[1])} followers in the last month
													</Tooltip>}
												>
													<span>
													{e.month && e.month[0] > 0 &&
														<span class="text-success fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-up" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													{e.month && e.month[0] < 0 &&
														<span class="text-danger fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-down" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													</span>
												</OverlayTrigger>
											}
											
										</p>

									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		const CustomizedTrains = (props) => {
  		//const { cx, cy, value } = props;
			const scale = 0.25;
			const shift = props.payload.twitch_bits ? -15 : 0;
			//console.log(props.payload);
			if( props.cy )
				return (
					<React.Fragment>
						<svg xmlns="http://www.w3.org/2000/svg">
							<title>twitch.train</title>
							<g id="train" transform={`translate(${props.cx-128*scale/2+shift},${props.cy-128*scale/2}) scale(${scale})`}>
								<rect x="15.48" y="25.49" width="5.07" height="18.91"/>
								<path d="M114.29,82.64V67.4a19.024,19.024,0,0,0-19-19H11.95a3.009,3.009,0,0,0-3,3v7.03H55.67a2,2,0,0,1,0,4H8.95V85.64H111.29A3,3,0,0,0,114.29,82.64Z"/>
								<path d="M26.1,105.643a2.774,2.774,0,1,0,2.775,2.773A2.776,2.776,0,0,0,26.1,105.643Z"/>
								<path d="M26.1,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,26.1,96.99Zm0,18.2a6.774,6.774,0,1,1,6.775-6.774A6.781,6.781,0,0,1,26.1,115.19Z"/>
								<rect x="24.55" y="25.49" width="21.55" height="18.91"/>
								<rect x="76.51" y="32.22" width="13.64" height="12.18"/>
								<rect x="6.95" y="8.16" width="56.74" height="13.33" rx="3"/>
								<rect x="50.1" y="25.49" width="5.06" height="18.91"/>
								<path d="M112.49,89.64H8.95v15.8a3.02,3.02,0,0,0,1.74,2.72,15.421,15.421,0,0,1,30.84.26v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h1.85a3.007,3.007,0,0,0,2.61-4.49Z"/>
								<path d="M100.76,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,100.76,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,100.763,115.19Z"/>
								<path d="M74.92,28.22H91.74a1.805,1.805,0,0,0,0-3.61H74.92a1.805,1.805,0,0,0,0,3.61Z"/>
								<path d="M100.763,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,100.763,105.643Z"/>
								<path d="M63.43,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,63.43,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,63.434,115.19Z"/>
								<path d="M63.434,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,63.434,105.643Z"/>
							</g>
						</svg>
						<text x={props.cx+5+shift} y={props.cy-15} fill="#6441A5">
							{props.payload._twitch_trains}
						</text>
					</React.Fragment>
			)
		}

		const CustomizedBits = (props) => {
  		//const { cx, cy, value } = props;
			const scale = 0.15;
			const shift = props.payload.twitch_trains ? 15 : 0;
			//console.log(props);
			if( props.cy )
				return (
					<React.Fragment>
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" transform={`translate(${props.cx-200*scale/2+shift},${props.cy-242*scale/2}) scale(${scale})`} width={200/scale/2} height={242/scale/2}>
							<path d="M0 0 C4.05740412 1.26013087 5.27852877 3.61501605 7.23046875 7.15625 C8.10236944 8.64091589 8.97480714 10.12526649 9.84765625 11.609375 C10.57227051 12.86717773 10.57227051 12.86717773 11.31152344 14.15039062 C13.71851866 18.27959459 16.22693106 22.34536516 18.72338867 26.42089844 C26.13616262 38.52595423 33.38963658 50.72517547 40.62149048 62.93884277 C46.21075013 72.37616411 51.84281674 81.78546917 57.54296875 91.15625 C57.88971649 91.72632782 58.23646423 92.29640564 58.59371948 92.88375854 C61.03290798 96.89261428 63.47526013 100.89953859 65.91796875 104.90625 C70.52617685 112.46631446 75.12894763 120.02953742 79.70846558 127.60702515 C81.54296251 130.64101515 83.38375955 133.67093316 85.23486328 136.69482422 C87.15169776 139.82611786 89.05649258 142.96444055 90.95333862 146.10787964 C91.67413396 147.2975099 92.39927433 148.48451938  93.12893677 149.66873169 C94.13523424 151.30337083 95.12468773 152.9483435 96.11328125 154.59375 C96.68062988 155.52574219 97.24797852 156.45773438 97.83251953 157.41796875 C98.91796875 159.90625 98.91796875 159.90625 98.75341797 162.09423828 C97.3398406 165.16015623 94.57018476 166.82861444 91.91796875 168.78125 C90.63257246 169.75839138 89.34878834 170.73765619 88.06640625 171.71875 C87.38803711 172.23566406 86.70966797 172.75257813 86.01074219 173.28515625 C82.45655641 176.03828196 79.0025516 178.91078605 75.54296875 181.78125 C74.09920313 182.9755564 72.6551918 184.16956584 71.2109375 185.36328125 C70.14045166 186.24814209 70.14045166 186.24814209 69.04833984 187.15087891 C63.69187759 191.5644663 58.29324365 195.92657804 52.90185547 200.29736328 C49.57190428 202.99787747 46.24510405 205.70226795 42.91796875 208.40625 C41.58465035 209.48960171 40.25131702 210.57293505 38.91796875 211.65625 C37.92796875 212.460625 37.92796875 212.460625 36.91796875 213.28125 C34.91796875 214.90625 32.91796875 216.53125 30.91796875 218.15625 C30.25716309 218.69354736 29.59635742 219.23084473 28.91552734 219.78442383 C27.59188562 220.85909408 26.26670652 221.93187376 24.93994141 223.00268555 C21.44286996 225.82936297 17.98440622 228.6912951 14.56640625 231.61328125 C13.85097656 232.2165625 13.13554688 232.81984375 
							12.3984375 233.44140625 C11.02893324 234.59748128 9.66892982 235.76493853 8.3203125 236.9453125 C5.52737086 239.28534468 3.52185518 240.75328668 -0.04296875 241.65625 C-4.68380191 240.51095441 -7.55264459 237.7176498 -11.08203125 234.59375 C-12.59772618 233.2967358 -14.11467023 232.00118001 -15.6328125 230.70703125 C-16.75937256 229.73757568 -16.75937256 229.73757568 -17.90869141 228.74853516 C-20.95736729 226.1642498 -24.10329361 223.71880066 -27.26953125 221.28125 C-32.60185477 217.1429231 -37.73405162 212.81247582 -42.83056641 208.38842773 C-47.4059726 204.43624326 -52.11711713 200.69206662 -56.89355469 196.98706055 C-60.95599803 193.82389755 -64.91595328 190.56110926 -68.83203125 187.21875 C-74.16393891 182.66907783 -79.57473307 178.24195219 -85.08203125 173.90625 C-85.67290527 173.44089844 -86.2637793 172.97554687 -86.87255859 172.49609375 C-90.93869468 169.29476637 -95.00906998 166.09888823 -99.08203125 162.90625 C-98.50746173 158.44877823 -96.68721666 155.10990283 -94.390625 151.33203125 C-94.01406265 150.69992233 -93.63750031 150.06781342 -93.24952698 149.41654968 C-92.01338906 147.34621214 -90.76668255 145.28246869 -89.51953125 143.21875 C-88.64991577 141.76786263 -87.78078069 140.31668723 -86.91210938 138.86523438 C-81.06806628 129.1192173 -75.12579926 119.43500658 -69.14208984 109.77416992 C-63.46027855 100.57977417 -57.94014885 91.29432011 -52.4382019 81.99157715 C-46.03668492 71.16959812 -39.55714797 60.39845548 -33.01513672 49.66088867 C-29.40010153 43.72654055 -25.80172475 37.78357783 -22.24438477 31.81445312 C-20.35053871 28.6418456 -18.43938874 25.47982958 -16.52783203 22.31787109 C-15.51181917 20.62314381 -14.50585419 18.92237184 -13.50732422 17.21728516 C-11.92650098 14.51828372 -10.31917173 11.83663103 -8.70703125 9.15625 C-8.23096436 8.32665771 -7.75489746 7.49706543 -7.2644043 6.64233398 C-3.9126875 1.15049873 -3.9126875 1.15049873 0 0 Z " fill="#A78AF8" transform="translate(99.08203125,0.09375)" />
							<path d="M0 0 C4.66097066 0.93219413 5.9219958 1.36027579 9.4140625 4.10546875 C10.66437256 5.07540771 10.66437256 5.07540771 11.93994141 6.06494141 C12.82601074 6.76538574 13.71208008 7.46583008 14.625 8.1875 C16.5198298 9.65884537 18.41568376 11.12887263 20.3125 12.59765625 C21.26640625 13.33902832 22.2203125 14.08040039 23.203125 14.84423828 C27.29814463 18.00057761 31.4543872 21.06961081 35.625 24.125 C36.78950684 24.98025269 36.78950684 24.98025269 37.97753906 25.8527832 C40.31720204 27.57010749 42.65834218 29.285397 45 31 C56.82505781 39.65851513 68.55244205 48.42975904 80.1953125 57.33203125 C85.76867354 61.59265849 91.37518127 65.80758853 97 70 C97.66 69.67 98.32 69.34 99 69 C99.33 70.65 99.66 72.3 100 74 C77.33333333 92.41666667 54.66666667 110.83333333 32 129.25 C31.33919434 129.78729736 30.67838867 130.32459473 29.99755859 130.87817383 C28.67391687 131.95284408 27.34873777 133.02562376 26.02197266 134.09643555 C22.52490121 136.92311297 19.06643747 139.7850451 15.6484375 142.70703125 C14.93300781 143.3103125 14.21757813 143.91359375 13.48046875 144.53515625 C12.11096449 145.69123128 10.75096107 146.85868853 9.40234375 148.0390625 C6.26000321 150.67183431 4.7181223 151.92624252 0.5390625 152.35546875 C-0.29882812 152.23816406 -1.13671875 152.12085938 -2 152 C-1.34 151.67 -0.68 151.34 0 151 C0 101.17 0 51.34 0 0 Z " fill="#CAB9FB" transform="translate(98,89)"/>
							<path d="M0 0 C2.73046875 -0.390625 2.73046875 -0.390625 6 0 C7.81976301 2.10399889 8.98894476 3.84878951 10.3125 6.25 C11.18440069 7.73466589 12.05683839 9.21901649 12.9296875 10.703125 C13.41276367 11.54166016 13.89583984 12.38019531 14.39355469 13.24414062 C16.80054991 17.37334459 19.30896231 21.43911516 21.80541992 25.51464844 C29.21819387 37.61970423 36.47166783 49.81892547 43.70352173 62.03259277 C50.99942662 74.35154075 58.39853091 86.60479715 65.85023499 98.83000183 C68.35380283 102.93737265 70.85217636 107.04786694 73.34765625 111.16015625 C73.70777802 111.75337677 74.06789978 112.34659729 74.43893433 112.95779419 C76.22708715 115.90382173 78.0135331 118.85086222 79.796875 121.79980469 C83.22867076 127.46971503 86.68992046 133.11804134 90.21484375 138.73046875 C91.2044812 140.31831177 91.2044812 140.31831177 92.21411133 141.93823242 C93.45754046 143.93054681 94.71080189 145.91676953 95.9753418 147.89575195 C96.52230713 148.77577881 97.06927246 149.65580566 97.6328125 150.5625 C98.11637207 151.32691406 98.59993164 152.09132812 99.09814453 152.87890625 C100.16612388 155.3907104 99.9449181 156.48781384 99 159 C98.55422607 158.64921387 98.10845215 158.29842773 97.64916992 157.93701172 C85.92813029 148.72900832 74.03309645 139.79483951 62 131 C49.39078611 121.77195455 36.91233404 112.38894706 24.49511719 102.90429688 C20.64919021 99.96904928 16.7980722 97.04095934 12.9375 94.125 C12.28885986 93.63112793 11.64021973 93.13725586 10.97192383 92.62841797 C8.03639771 90.41722199 5.30585421 88.65292711 2 87 C2.33 58.62 2.66 30.24 3 1 C2.01 0.67 1.02 0.34 0 0 Z " fill="#AF85F6" transform="translate(96,1)"/>
							<path d="M0 0 C1.32 0 2.64 0 4 0 C4.25528132 11.07429406 4.45052347 22.14788448 4.56993389 33.22452545 C4.62725805 38.36851681 4.70495042 43.5104904 4.82983398 48.65332031 C4.94968479 53.62019027 5.01519065 58.58512481 5.04364967 63.55332947 C5.06391858 65.44496637 5.10350468 67.33650145 5.16303062 69.22731018 C5.61064323 84.03958764 5.61064323 84.03958764 1.65371704 88.85580444 C-1.14671285 90.90867726 -3.90130552 92.44761565 -7 94 C-8.69197262 95.22891336 -10.36302737 96.4877862 -12 97.7890625 C-12.81404297 98.41296875 -13.62808594 99.036875 -14.46679688 99.6796875 C-15.30275391 100.32164063 -16.13871094 100.96359375 -17 101.625 C-23.78555486 106.81708766 -30.60664115 111.95193582 -37.5 117 C-44.22503265 121.925594 -50.88000868 126.93415128 -57.5 132 C-64.47353586 137.32729439 -71.46051234 142.63503949 -78.5 147.875 C-79.28310547 148.46410156 -80.06621094 149.05320313 -80.87304688 149.66015625 C-84.45711865 152.31432374 -87.68978107 154.64878057 -92 156 C-91.42800085 151.47504022 -89.53179097 148.08193695 -87.203125 144.25 C-86.81835999 143.60421997 -86.43359497 142.95843994 -86.03717041 142.29309082 C-84.78196162 140.19099795 -83.5162269 138.09547112 -82.25 136 C-81.37257048 134.53609273 -80.49562077 133.07189776 -79.61914062 131.60742188 C-74.48695593 123.0485564 -69.27593913 114.54089359 -63.98632812 106.07836914 C-59.12206982 98.26807674 -54.43435835 90.35638791 -49.75 82.4375 C-42.88502736 70.8323252 -35.94929727 59.27417712 -28.93603516 47.75805664 C-25.30907554 41.80217557 -21.6926135 35.84074935 -18.11108398 29.85742188 C-17.13991788 28.23514211 -16.16685313 26.61399705 -15.19165039 24.99414062 C-12.75008294 20.93803624 -10.33801613 16.86771651 -7.9609375 12.7734375 C-6.97410971 11.09886912 -5.98713597 9.42438673 -5 7.75 C-4.55479004 6.96802246 -4.10958008 6.18604492 -3.65087891 5.38037109 C-3.22983887 4.67219238 -2.80879883 3.96401367 -2.375 3.234375 C-2.01148437 2.60756836 -1.64796875 1.98076172 -1.2734375 1.33496094 C-0.85320312 0.89442383 -0.43296875 0.45388672 0 0 Z " fill="#7B36F0" transform="translate(95,2)"/>
						</svg>
						{/*<text x={props.cx+5} y={props.cy-15} fill="#6441A5">
							{props.payload._twitch_trains}
						</text>*/}
					</React.Fragment>
			)
		}

		const CustomTooltip = ({ active, payload, label }) => {
			const isVisible = active && payload && payload.length;
			return (
				<div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden', backgroundColor: '#ffffff' }}>
					{isVisible && (
						<>

							<div xmlns="http://www.w3.org/1999/xhtml" tabindex="-1" class="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom" style={{visibility: 'visible'}}>
								<div class="recharts-default-tooltip" style={{margin: 0, padding: 10, backgroundColor: 'rgb(255, 255, 255)', border: '1px solid rgb(204, 204, 204)', whiteSpace: 'nowrap'}}>
									<p class="recharts-tooltip-label" style={{margin: 0}}>{label}</p>
									<ul class="recharts-tooltip-item-list" style={{padding: 0, margin: 0}}>
										{payload[0].payload._twitch_bits &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: '#6441A5'}}>
												<span class="recharts-tooltip-item-name">Twitch Bits: {payload[0].payload._twitch_bits}</span>
											</li>
										}
										{payload[0].payload.twitch_subscribe &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: '#6441A5'}}>
												<span class="recharts-tooltip-item-name">Twitch Subscribe: {payload[0].payload.twitch_subscribe}</span>
											</li>
										}
										{payload[0].payload._twitch_trains &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: '#6441A5'}}>
												<span class="recharts-tooltip-item-name">Twitch Trains: {payload[0].payload._twitch_trains}</span>
											</li>
										}
										{Object.keys(payload[0].payload).map((e, i) =>{
											//console.log(typeof payload[0].payload[e]);
											if( typeof payload[0].payload[e] === 'object' )
												return (
													<li key={i} class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: '#4169E1'}}>
														<span class="recharts-tooltip-item-name">{e} Followers: {payload[0].payload[e].length}</span>
														<div className="d-flex">
															<div className="avatar-list-stacked">
																{payload[0].payload[e].map((f, j) =>{
																	return (
																		<div key={j} className="avatar avatar-md" >
																			<img alt="avatar" className="rounded-circle" src={f.avatar} />
																		</div>
																	)
																})}
															</div>
														</div>
													</li>
												)
										})}
										{/*<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
											<span class="recharts-tooltip-item-name">value</span>
											<span class="recharts-tooltip-item-separator"> : </span>
											<span class="recharts-tooltip-item-value">2</span>
											<span class="recharts-tooltip-item-unit"></span>
										</li>*/}
										
									</ul>
								</div>
							</div>


							{/*<p className="label">{`${label} : ${payload[0].value}`}</p>
							<p className="intro">Something</p>
							<p className="desc">Anything you want can be displayed here.</p>*/}
						</>
					)}
				</div>
			);
		};
		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Analytics</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Analytics</span>
													<p className="fs-13 text-muted mb-0">View your radio station analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row>
								{followers}
							</Row>
							<Row>
								<Col xs={12}>
									<div className="card">
										<div className="card-body">
											<p className="my-0">
												Date period: {moment(this.state.start*1000).format('DD-MMM-YY')} to {moment(this.state.end*1000).format('DD-MMM-YY')}
											</p>
											<ButtonGroup size="sm" className="py-2">
												<Button variant={this.state.view.charts==='platforms'?'outline-dark':'light'} onClick={()=>this.setView('platforms')}>Station</Button>
												<Button variant={this.state.view.charts==='djs'?'outline-dark':'light'} onClick={()=>this.setView('djs')}>DJ'S</Button>
												<Button variant={'light'}></Button>

												{this.state.view.charts === 'platforms' &&
													this.state.platforms.platforms.map((e,i) => {
														//console.log(this.state.platforms.platforms);
														return (
															<React.Fragment key={i}>
																{e.length > 0 ?
																	<Button variant={this.state.view.page===i?'outline-dark':'light'} onClick={()=>this.setView('platforms', i)}>{moment(e[0].ctime*1000).format('MMM YY')}</Button>
																:
																	<></>
																}
															</React.Fragment>
														)
													})}
												{this.state.view.charts === 'djs' &&
													this.state.djsChart.map((e, i)=>{
														return (
															<React.Fragment key={i}>
																<button onClick={()=>this.sortDjs(e.bar)} style={{backgroundColor: e.fill, color: '#ffffff', borderColor: e.fill, padding: '0 .5rem', borderRight: 0}}>
																	{e.bar.charAt(0).toUpperCase() + String(e.bar).slice(1)}
																</button>
																<button onClick={()=>this.sortDjs(e.bar, !e.enabled)} style={{backgroundColor: e.fill, color: '#ffffff', borderColor: e.fill, padding: '0 .5rem', borderLeft: 0}}>
																	{e.enabled === true ?
																		<span className="custom-check"><FontAwesomeIcon icon="square-check" /></span>
																	:
																		<span className="custom-check"><FontAwesomeIcon icon="square" /></span>
																	}
																</button>
															</React.Fragment>
														)
													})}
											</ButtonGroup>

											{this.state.view.charts === 'platforms' &&

												<LineChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.platforms.platforms[this.state.view.page]}
													margin={{
														top: 5,
														right: 10,
														left: 0,
														bottom: 5,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="date" />
													<YAxis width="auto" />
													<Tooltip1 content={CustomTooltip} />
													<Legend />
													
													<Line type="monotone" dataKey="value" stroke="#4169E1" /*dot={CustomizedDot}*/ />
													<Line type="monotone" dataKey="twitch_trains" stroke="#6441A5" dot={CustomizedTrains} />
													<Line type="monotone" dataKey="twitch_bits" stroke="#6441A5" dot={CustomizedBits} />
													{/*this.state.platforms.followers.map((e,i) => {
														return (
															<Line key={i} type="monotone" dataKey={e.platform} stroke="#8884d8" /*dot={CustomizedDot}* />
														)
													})*/}
												</LineChart>
											}
											{this.state.view.charts === 'djs' &&
												<BarChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.djs}
													margin={{
														top: 20,
														right: 0,
														left: 0,
														bottom: 50,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="username" tick={{textAnchor: "end"}} angle={-35} />
													<YAxis width="auto" />
													<Tooltip1 />
													<Legend verticalAlign="top" />
													{this.state.djsChart.filter(elem=>elem.enabled===true).map((e, i)=>{
														return (
															<Bar key={i} dataKey={e.bar} stackId={parseInt(i)===0?'a':'b'} label={{fill: 'white'}} fill={e.fill} background />
														)
													})}
												</BarChart>
											}
										</div>
									</div>
								</Col>
								
							</Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Analytics = props => {
  const { service } = useParams();
  const navigate = useNavigate();
  return <PortalServiceAnalytics service={service} navigate={navigate} {...props} />
}
export default Analytics;